/** Código fuente y texto de la licencia. El repositorio debe ser público para que el enlace resuelva (ver add-gpl-license-and-attribution, 3.2). */
export const SOURCE_URL = 'https://github.com/alascorporation/openRocket-web';
export const LICENSE_URL = 'https://www.gnu.org/licenses/gpl-3.0.html';

/** Aviso de licencia: GPL-3.0-only, decidida por el titular (docs/legal/license-decision.md). */
export const LICENSE_NOTICE = 'Este programa es software libre: se distribuye bajo la licencia GPL-3.0 (solo la versión 3). Puedes usarlo, estudiarlo, modificarlo y redistribuirlo bajo esos términos, y se ofrece sin garantía.';

/** Contenido del diálogo «Acerca de» (el título lo pone el diálogo). */
export function About(): JSX.Element {
  return (
    <div className="about">
      <h3>Qué es</h3>
      <p>
        Un simulador de cohetes de modelismo que funciona por completo en tu navegador: diseñas el cohete, ves su estabilidad y simulas el vuelo. Los cálculos se hacen en tu equipo
        y <strong>ningún diseño ni resultado se envía a un servidor</strong>.
      </p>

      <h3>Licencia</h3>
      <p>{LICENSE_NOTICE}</p>
      <ul>
        <li>
          <a href={SOURCE_URL} target="_blank" rel="noopener noreferrer">Código fuente</a>
        </li>
        <li>
          <a href={LICENSE_URL} target="_blank" rel="noopener noreferrer">Texto de la licencia GPL-3.0</a>
        </li>
      </ul>

      <h3>Independencia</h3>
      <p>
        Esta es una implementación independiente. Se validó comparando sus resultados con los que guardan los archivos de ejemplo de OpenRocket, pero <strong>no está afiliada a
        OpenRocket</strong> ni a sus autores, y no copia su código. La procedencia exacta, con sus limitaciones, está descrita en el archivo ATTRIBUTION.md del código fuente.
        «OpenRocket» es un proyecto de terceros.
      </p>

      <h3>Referencias</h3>
      <ul>
        <li>J. S. Barrowman y J. A. Barrowman, <em>The Theoretical Prediction of the Center of Pressure</em>, NARAM-8, 1966.</li>
        <li>J. S. Barrowman, <em>The Practical Calculation of the Aerodynamic Characteristics of Slender Finned Vehicles</em>, tesis, 1967.</li>
        <li>S. Niskanen, <em>Development of an Open Source model rocket simulation software</em>, tesis de máster, 2009.</li>
        <li>S. F. Hoerner, <em>Fluid-Dynamic Drag</em>, 1965; H. Schlichting y K. Gersten, <em>Boundary-Layer Theory</em>.</li>
        <li>ISO 2533:1975, atmósfera estándar; NIMA TR8350.2, WGS84.</li>
      </ul>

      <h3>Límites</h3>
      <ul>
        <li>Cohetes de una etapa, con aletas trapezoidales y un motor.</li>
        <li>La aerodinámica supersónica (resistencia de onda) no está modelada; se avisa a partir de Mach 1.</li>
        <li>Los diseños importados pierden los componentes que no se modelan (cordón, lastre, anillos…), lo que cambia su masa y sus resultados. El informe de importación lo detalla.</li>
        <li>Las tolerancias frente a OpenRocket se midieron con 13 simulaciones de 5 diseños; no garantizan la misma exactitud en general.</li>
      </ul>
    </div>
  );
}
